module.exports = __webpack_public_path__ + "static/media/agile-logo.858947e8.svg";